module.exports = flarum.reg.get('core', 'common/SearchManager');